export default __webpack_public_path__ + "static/media/aboutme.acba0742.png";